module.exports = __webpack_public_path__ + "img/wuqigoujian.4cd1150c.png";